//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseViewObject = require('@/tbs/model/vo/BaseViewObject')
const ClassFunc = require('@/tbs/util/ClassFunc')
const DateTimeFunc = require('@/tbs/util/DateTimeFunc')
const MatchSignupPayment = require('@/tbs/model/to/MatchSignupPayment')
const matchSignupPayment = new MatchSignupPayment
/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_MatchSignupContestantConfig = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseViewObject, arguments)
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchSignupContestantConfig.prototype = {
    /* The view object name */
    name: 'matchGroup',
    /* The view object instance */
    view: {
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMMatchPlayerSignupLimit',
            query: {
                matchId: 'id',
            },
            basePath: 'data',
            rule: {
                id: '$id',
                teamNumMin: '$teamMemberLeastCount,playerCountASide',
                teamNumMax: '$teamMemberLimitCount',
                genderRestriction: '$genderLimit',
                maleNumMin: 'maleMin',
                maleNumMax: 'maleMax',
                femaleNumMin: 'femaleMin',
                femaleNumMax: 'femaleMax',
                ageBirthMin: '$maxAge',
                ageBirthMax: '$minAge',
                numSelection: '~playerCountASide',
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateBMMatchPlayerSignupLimit',
            basePath: '',
            rule: {
                matchId: 'id',
                teamMemberLeastCount: 'teamNumMin',
                teamMemberLimitCount: '$teamNumMax',
                genderLimit: '$genderRestriction',
                maleMin: 'maleNumMin',
                maleMax: 'maleNumMax',
                femaleMin: 'femaleNumMin',
                femaleMax: 'femaleNumMax',
                isOpenAgeLimit: '$ageBirthMin,ageBirthMax',
                minAge: '$ageBirthMax',
                maxAge: '$ageBirthMin',
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderId: function(id, options) {
        return options.parameters.matchId
    },
    formatTeamMemberLimitCount: function(teamNumMax) {
        return this._formatMaxNum(teamNumMax)
    },
    renderTeamNumMin: function(teamMemberLeastCount, playerCountASide) {
        teamMemberLeastCount = teamMemberLeastCount || 0
        playerCountASide = playerCountASide || 1
        return Math.max(teamMemberLeastCount, playerCountASide)
    },
    renderTeamNumMax: function(teamMemberLimitCount) {
        return this._renderMaxNum(teamMemberLimitCount)
    },
    formatIsOpenAgeLimit: function(ageBirthMin, ageBirthMax) {
        if (ageBirthMin || ageBirthMax) {
            return 1
        }
        return 0
    },
    formatMaxAge: function(ageBirthMin) {
        if (ageBirthMin) {
            ageBirthMin = DateTimeFunc.formatDate(ageBirthMin)
        }
        return this._formatStartDate(ageBirthMin)
    },
    formatMinAge: function(ageBirthMax) {
        if (ageBirthMax) {
            ageBirthMax = DateTimeFunc.formatDate(ageBirthMax)
        }
        return this._formatEndDate(ageBirthMax)
    },
    renderAgeBirthMax: function(minAge) {
        minAge = this._renderEndDate(minAge)
        if (minAge) {
            return new Date(minAge)
        }
    },
    renderAgeBirthMin: function(maxAge) {
        maxAge = this._renderStartDate(maxAge)
        if (maxAge) {
            return new Date(maxAge)
        }
    },
    formatGenderLimit: function(genderRestriction) {
        let genderLimit = 3
        if (genderRestriction == '1') {
            genderLimit = 3
        }
        else if (genderRestriction == '2') {
            genderLimit = 1
        }
        else if (genderRestriction == '3') {
            genderLimit = 2
        }
        else if (genderRestriction == '4') {
            genderLimit = 0
        }
        return genderLimit
    },
    renderGenderRestriction: function(genderLimit) {
        let genderRestriction = '1'
        if (genderLimit == 0) {
            genderRestriction = '4'
        }
        else if (genderLimit == 1) {
            genderRestriction = '2'
        }
        else if (genderLimit == 2) {
            genderRestriction = '3'
        }
        else if (genderLimit == 3) {
            genderRestriction = '1'
        }
        return genderRestriction
    },
    genderRestrictionTypeOptions: [
        { label: matchSignupPayment.localeProp('gender-restriction-type-1'), value: '1' },
        { label: matchSignupPayment.localeProp('gender-restriction-type-2'), value: '2' },
        { label: matchSignupPayment.localeProp('gender-restriction-type-3'), value: '3' },
        { label: matchSignupPayment.localeProp('gender-restriction-type-4'), value: '4' },
    ],
}

//--------------------------------------------------
// extends the BaseViewObject
//--------------------------------------------------
ClassFunc.extend(tbs_model_vo_MatchSignupContestantConfig, BaseViewObject);

module.exports = tbs_model_vo_MatchSignupContestantConfig